var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13 11.8h1.042a.614.614 0 0 0 .613-.61v-.825H.517v.824c0 .336.276.611.613.611Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.785 11.082H.915a.839.839 0 0 1-.398-.093v-.653h2.268v.746Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.987 4.938H.58A.58.58 0 0 1 0 4.356v-.06a.58.58 0 0 1 .58-.583h1.407v1.225ZM12.685 4.938h1.406a.58.58 0 0 0 .58-.582v-.06a.58.58 0 0 0-.58-.583h-1.406v1.225Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.342.435a18.77 18.77 0 0 0-8.04 0C2.63.588 2.08 1.23 1.928 1.963 1.591 3.583 1.255 5.11.92 6.546h12.776a186.147 186.147 0 0 1-1.009-4.583c-.122-.703-.703-1.375-1.344-1.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.604 4.479c-.153-.733-.336-1.527-.52-2.382-.09-.488-.488-.946-.885-1.038a18.416 18.416 0 0 0-3.88-.427h-.61c-.306 0-.611.03-.947.06l-.917.092-.641.092c-.214.092-.49.153-.733.214-.398.091-.795.519-.886 1.007-.061.367-.153.733-.214 1.069-.061.305-.122.61-.183.885-.031.153-.062.275-.092.428h10.508Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 10.623H.912a.726.726 0 0 1-.704-.827V6.857a2.134 2.134 0 0 1 2.11-1.775h9.97c1.04 0 1.926.735 2.11 1.775v2.94c.091.428-.245.826-.704.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.686 10.623H.911a.726.726 0 0 1-.703-.827V6.857c.061-.398.245-.765.52-1.04.397-.46.978-.735 1.589-.735h9.964c.641 0 1.222.275 1.589.735.244.275.428.642.489 1.04v2.94c.122.428-.214.826-.673.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.024 10.594H.91a.724.724 0 0 1-.7-.824V6.838c.06-.397.243-.764.517-1.038 2.348.58 4.116 2.32 4.298 4.794Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.513 11.8H12.47a.614.614 0 0 1-.613-.61v-.825h2.268v.824c0 .336-.276.611-.613.611Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.829 11.082h1.87a.839.839 0 0 0 .398-.093v-.653H11.83v.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.693 10.594H9.59C9.773 8.09 11.55 6.35 13.908 5.8c.245.274.428.64.49 1.038V9.77c.092.427-.245.824-.705.824Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.263 7.608)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.092,
    cy: 1.099,
    rx: 1.069,
    ry: 1.072
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.022,
    cy: 1.099,
    rx: 1.069,
    ry: 1.072
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.056.333h4.002v1.47H4.056z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default ForwardRef;